// extracted by mini-css-extract-plugin
export default {"Wrapper":"DialogResetPassword_Wrapper__aqL9p","FieldItem":"DialogResetPassword_FieldItem__Lg+v3"};